<template>
    <div
        v-show="show"
        v-on-clickaway="onClickAway"
        class="popover"
        role="tooltip"
    >
        <div class="popover__body">
            <slot>Popover content</slot>
        </div>
    </div>
</template>

<script>
import { mixin as clickaway } from 'vue-clickaway';

export default {
    name: 'popover',

    mixins: [clickaway],

    props: {
        show: {
            type: Boolean,
            default: false,
        },
    },

    methods: {
        onClickAway() {
            if (this.show) {
                this.$emit('close-popover');
            }
        },
    },
};
</script>

<style lang="scss">
@import "../../styles/includes";

.popover {
    position: absolute;
    top: 0;
    left: 0;
    z-index: $zindex-modal-level-2;
    display: block;
    min-width: 160px;
    max-width: 400px;
    word-wrap: break-word;
    color: var(--form-inputColor);
    background-color: var(--form-inputBackgroundColor);
    border: 1px solid var(--form-inputBorderColor);
    background-clip: padding-box;
    border-top: none;
    font-size: 13px;

    &--right {
        margin-left: 30px;
        margin-top: -20px;
    }

    li:hover {
        color: var(--form-inputHoverColor);
        background-color: var(--form-inputHoverBackgroundColor);
    }
}
</style>
